/** Shared cell recipes of the run-history tables. */
export const NO_WRAP_CELL_SX = {
  whiteSpace: "nowrap" as const,
  overflow: "hidden" as const,
  textOverflow: "ellipsis" as const,
};

export const HEADER_CELL_SX = { fontWeight: 700 } as const;
